const data = {
  "productCard": {
    "helpWithProduct": "Hulp bij het gebruik van dit product"
  },
  "lastOrder": {
    "heading": "Je laatste bestelling",
    "description": "Download je factuur, meld een retour aan of ontdek tips voor het gebruik van je product.",
    "viewAllOrders": "Bekijk al je bestellingen"
  },
  "orderStatus": {
    "title": "Status van je bestelling",
    "trackAndTrace": "Track & Trace",
    "customerService": "Klantenservice",
    "inviteToPay": "Bestelling afronden",
    "status": {
      "paid": "Betalen",
      "packed": "Inpakken",
      "outForDelivery": "Onderweg",
      "delivered": "Bezorgd"
    }
  },
  "orderOverview": {
    "orderedOn": "Besteld op",
    "viewOrder": "Bekijk bestelling",
    "downloadInvoice": "Download factuur",
    "downloadInvoiceWithIndex": "Download factuur {{ index }}",
    "secondChanceProduct": "Tweedekans product"
  },
  "multipleShipments": {
    "shipmentXOfY": "Deel {{shipmentNumber}} van {{shipmentTotal}}",
    "heading": "Je bestelling wordt in meerdere delen geleverd",
    "description": "<url>Bekijk je bestelling</url> om de delen te volgen"
  }
};

export default data;